import React from "react";
import cx from "classnames";
import styles from "./HelpSectionItem.module.scss";
import Icon from "../../../components/Icon/Icon";
import { IconSetIds } from "../../Icon/IconMap";

interface IHelpSectionItemProps {
    iconId: IconSetIds;
    title: string;
    link: string;
    href?: string;
    onClick?: () => void;
}

const HelpSectionItem: React.FC<IHelpSectionItemProps> = (props) => {
    const { iconId, title, link, href, onClick, children } = props;

    return (
        <div className={cx(styles["container"], "flex-gap-m", "layout-fit-content")}>
            <a href={href} onClick={onClick} className="text-line-height-none">
                <Icon className={styles["icon"]} id={iconId} />
            </a>
            <div className="layout-flex-column">
                <span
                    className={cx(
                        "text-bold",
                        "text-font-size-ml",
                        "text-line-height-xl",
                        "text-section-header"
                    )}>
                    {title}
                </span>
                <a href={href} onClick={onClick} className={"gap-m"}>
                    {link}
                </a>

                {children}
            </div>
        </div>
    );
};

export default HelpSectionItem;
